export class Role {
    RoleId: number;
    ClientId: number;
    RoleName: string;
    LoweredRoleName: string;
    Description: string;
    CreatedBy: number;
    CreatedDate?: Date;
}